import { useQuery } from '@tanstack/react-query';
import { getTaskPriorityLevels } from 'api/tasks';
import { priorityLevelsKeys } from 'api/queryKeys';

export const useTaskPriorityLevelsQuery = () => {
  return useQuery({
    queryKey: priorityLevelsKeys.all(),
    queryFn: () => getTaskPriorityLevels().then((res) => res.data ?? [])
  });
};
